import React from 'react';
export function HeroSection() {
  return <div className="bg-[#002d4d] py-16 px-4 relative overflow-hidden" data-id="element-380">
      <div className="absolute inset-0 opacity-10" data-id="element-381">
        <div className="absolute -right-20 -top-20 w-96 h-96 rounded-full border-[20px] border-white" data-id="element-382"></div>
        <div className="absolute -left-20 -bottom-20 w-64 h-64 rounded-full border-[15px] border-white" data-id="element-383"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-384">
        <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight mb-2" data-id="element-385">
          Bodor Laser
        </h1>
        <h2 className="text-2xl md:text-3xl font-medium text-white/90" data-id="element-386">
          Fiber Laser Plate &amp; Sheet Cutting
        </h2>
      </div>
    </div>;
}